import lsrestclient, {
  TLsRestClientCall,
} from '@shared/legacy_compat/lsrestclient/index';
import {
  TPaginationParameter,
  TPaginationResponse,
} from '@shared/types/pagination';
import { TGroupTag } from '@shared/types/group_tag';
import { withPaginationParameters } from '@shared/components/LsPagination/functions';

//Old get call to /pim/group_tags should not be used anymore
//Old get call to /pim/group_tags_search should not be used anymore

type TApiGroupTagsReadParameter = TPaginationParameter & {
  uids?: string[];
};

export const apiGroupTagsRead = async ({
  uids,
  ...parameter
}: TLsRestClientCall<TApiGroupTagsReadParameter>): Promise<
  TPaginationResponse<TGroupTag> | undefined
> => {
  const client = lsrestclient.client();
  return await client(
    withPaginationParameters(
      {
        method: 'put',
        url: '/pim/group_tags',
        params: {
          view: 'FULL',
        },
        body: {
          filter: {
            uids,
          },
        },
      },
      parameter,
    ),
  );
};

type TApiGroupTagsSearchParameter = TPaginationParameter & {
  searchTerm?: string;
};

export const apiGroupTagsSearch = async ({
  searchTerm,
  ...parameter
}: TLsRestClientCall<TApiGroupTagsSearchParameter>): Promise<
  TPaginationResponse<TGroupTag> | undefined
> => {
  const client = lsrestclient.client();

  return await client(
    withPaginationParameters(
      {
        method: 'put',
        url: '/pim/group_tags_search',
        params: {
          view: 'FULL',
          search_terms: searchTerm,
        },
        body: {},
      },
      parameter,
    ),
  );
};
